import { emailValidationRegex } from "constants/emailValidationRegex";
import { object, string, array } from "yup";

export const invoiceCustomerValidation = object({
  email: string()
    .nullable()
    .matches(emailValidationRegex, "Please enter a valid email"),
  recipient_emails: array()
    .of(
      string().matches(
        emailValidationRegex,
        "Please enter valid email addresses"
      )
    )
    .nullable(),
  company_name: string().required("Company name is required"),
});
